import { Box } from "@mui/material";
import React from "react";
import { formatDate } from "features/helpers/utils";
import IconIcDiscordSquare from "@metacrm/metacrm-svg/dist/SvgIcon/svg-icons/IconIcDiscordSquare";
import { StyledSkeleton } from "./WidgetPreview.styles";
import { useOutletContext } from "react-router";
export default function DiscordPreview({ formData, disabled }) {
  const { title, content, image, buttonText, buttonUrl, sendTime } = formData;
  const [entityName] = useOutletContext();

  return (
    <Box
      sx={{
        minHeight: "609px",
        p: "24px 64px 24px 36px",
        opacity: disabled ? 0.5 : 1,
      }}
      display="flex"
    >
      <IconIcDiscordSquare style={{ borderRadius: "50%" }} />
      <Box ml="16px" width="100%">
        <Box className="item-flex">
          <Box color="#F36A6A" fontWeight={700} fontSize={16}>
            {entityName}
          </Box>
          <Box ml="4px" fontSize={12} color="#747F8D" fontWeight={350}>
            {sendTime
              ? formatDate(sendTime, { time: true })
              : formatDate(Date.now(), { time: true })}
          </Box>
        </Box>
        {content ? (
          <Box sx={{ mt: "2px", color: "#555", wordBreak: "break-all" }}>
            {content}
          </Box>
        ) : (
          <Box mt="8.5px">
            <StyledSkeleton light mb="8px" height="13px" />
            <StyledSkeleton light mb="8px" width="242px" height="13px" />
          </Box>
        )}
      </Box>
    </Box>
  );
}
